
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"defaultPageContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInterface"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"typeHandle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uri"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_page_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flexibleSection"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleSections"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"socialFragment"},"directives":[]}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"localized"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_specialPage_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkField"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CraftLink"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultImageAsset"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"heroShortSrcset"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"flexibleSection"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleSections"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"socialFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"salesBlock"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"salesBlock_salesContact_BlockType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heading"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"},"directives":[]}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"localized"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1253}};
    doc.loc.source = {"body":"#import \"../flexibleSections/flexibleSections.graphql\"\n#import \"~/graphql/fragments/socialFragment.graphql\"\n#import \"~/graphql/fragments/localized.graphql\"\n#import \"~/graphql/fragments/fields/contact.graphql\"\n\n#import \"~/graphql/fragments/assets/defaultImageAsset.graphql\"\n#import \"~/graphql/fragments/assets/srcsets/heroShort.graphql\"\n#import \"~/graphql/fragments/components/CraftLink.graphql\"\nfragment defaultPageContent on EntryInterface {\n    typeHandle\n    title\n    uri\n    url\n\n    ... on page_page_Entry {\n        flexibleSection {\n            ... flexibleSections\n        }\n        seo {\n            ... socialFragment\n        }\n        ... localized\n    }\n\n    ... on page_specialPage_Entry {\n        linkField {\n            ... CraftLink\n        }\n        description\n        image {\n            ... DefaultImageAsset\n            ... heroShortSrcset\n        }\n        flexibleSection {\n            ... flexibleSections\n        }\n        seo {\n            ... socialFragment\n        }\n        salesBlock {\n            ... on salesBlock_salesContact_BlockType {\n                heading\n                description\n                contact {\n                    ... Contact\n                }\n            }\n        }\n        ... localized\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../flexibleSections/flexibleSections.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/socialFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/localized.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/fields/contact.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/assets/defaultImageAsset.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/assets/srcsets/heroShort.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/components/CraftLink.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["defaultPageContent"] = oneQuery(doc, "defaultPageContent");
        
